document.addEventListener 'DOMContentLoaded', ->


  # --- Akce po "kliknutí" (ručně volaná) ---
  handleSelect = (btn) ->
    return unless btn?
    $('.themes_photo_product_selector').removeClass 'active'
    $(btn).addClass 'active'
    scrollToActive()
    containerReload(true)


  $(document).on 'change', '.theme_filter', ->
    containerReload()

  $(document).on 'mouseover', '.theme_image', (e) ->

    console.log 'mouseover'

    if $(this).data('other_images') == 0
        return false

    imgElement = $(this)
    imgSrc = imgElement.attr('src')
    
    baseSrc = imgSrc.replace(/-\d\.jpg$/, '')  # Odstraní aktuální index

    images = []

    for i in [1..$(this).data('other_images')]
      images.push "#{baseSrc}-#{i}.jpg"


    console.log(images)


    cycleImages(imgElement, images)

  $(document).on 'mouseout', '.theme_image', (e) ->

    if $(this).data('other_images') == 0
        return false

    console.log 'mouseout'
    imgElement = $(this)
    stopCycleImages(imgElement)
    # Nastav původní obrázek zpět

    imgElement.attr 'src', imgElement.data 'base_img'
    return

  # --- Šipky – definice musí být před containerReload (kvůli hoistingu) ---
  updateArrows = ->
    track = document.getElementById 'sizesTrack'
    btnL  = document.getElementById 'navLeft'
    btnR  = document.getElementById 'navRight'
    return unless track? and btnL? and btnR?
    maxScroll = track.scrollWidth - track.clientWidth
    btnL.disabled = track.scrollLeft <= 1
    btnR.disabled = track.scrollLeft >= maxScroll - 1

  # --- AJAX RELOAD ---
  loadMore = (link) ->
    $link = $(link)
    return if $link.hasClass 'loading'
    $link.addClass 'loading'

    $.ajax(
      url: '/ajax/themes_container_reload/'
      type: 'POST'
      dataType: 'JSON'
      data: reloadData($link.data('offset'))
    ).done((data) ->
      $new = $('<div>').html data.html_output
      $('#themesContainerWrapper .inner_flex_container').append $new.find('.theme_cont')
      $('.themes_load_more_wrap').remove()
      $('#themesContainerWrapper .scrollbar').append $new.find('.themes_load_more_wrap')
    ).fail (jqXHR) ->
      $link.removeClass 'loading'
      console.error jqXHR.responseText

  $(document).on 'click', '.themes_load_more', (e) ->
    e.preventDefault()
    loadMore this

  reloadData = (offset = 0) ->
    filters: $('input[name="theme_filter[]"]:checked').map((_, el) -> el.value).get()
    photo_product: $('.themes_photo_product_selector.active').data('photo_product') or null
    in_app: $('input[name=themes_in_app]').val()
    app_photo_product: $('input[name=themes_app_photo_product]').val()
    app_product_id: $('input[name=app_product_id]').val()
    offset: offset

  containerReload = (refresh_filter = false) ->
    container = $('#themesContainerWrapper')
    active = $('.themes_photo_product_selector.active').data('photo_product') or null
    
    filters = $('input[name="theme_filter[]"]:checked')
      .map((_, el) => el.value)
      .get();

    console.log(filters);

    if (refresh_filter)
      $('input.theme_filter').prop('checked', false)



    container.html '<div class="themes-loader"><div class="themes-spinner"></div></div>'

    $.ajax(
      url: '/ajax/themes_container_reload/'
      type: 'POST'
      dataType: 'JSON'
      data: reloadData(0)

    ).done((data) ->
      console.log(data)

      console.log('RELOAAADß')

      $('.theme_filter_pill').addClass 'hidden'
      for filter in data.available_filters
        console.log('input.theme_filter[value=' + filter + ']')
        $('.theme_filter_pill#f_pill_' + filter).removeClass 'hidden'

      updateArrows()


      container.html data.html_output
      # $('.scrollbar').scrollbar();
    ).fail (jqXHR) ->
      console.error jqXHR.responseText

  # Pokud žádná položka není aktivní, zaaktivuj první
  if $('.themes_photo_product_selector.active').length == 0
    $('.themes_photo_product_selector').first().addClass 'active'

  containerReload(true)

  # --- SCROLL / DRAG HANDLING ---
  track = document.getElementById 'sizesTrack'
  btnL  = document.getElementById 'navLeft'
  btnR  = document.getElementById 'navRight'
  return unless track? and btnL? and btnR?

  # Vycentruje track na aktivní položku
  scrollToActive = ->
    if track.clientWidth == 0
      return

    active = track.querySelector '.themes_photo_product_selector.active'

    if active == null
      active = track.querySelector '.themes_photo_product_selector'

    if active == null
      return

    if active.classList.contains('active') == false
      active.classList.add 'active'

    trackRect  = track.getBoundingClientRect()
    activeRect = active.getBoundingClientRect()
    if activeRect.left < trackRect.left
      track.scrollLeft -= (trackRect.left - activeRect.left) + 20
    else if activeRect.right > trackRect.right
      track.scrollLeft += (activeRect.right - trackRect.right) + 20

  scrollByAmount = (px) ->
    track.scrollBy left: px, behavior: 'smooth'

  btnL.addEventListener 'click', -> scrollByAmount -Math.max(240, track.clientWidth * 0.6)
  btnR.addEventListener 'click', -> scrollByAmount  Math.max(240, track.clientWidth * 0.6)

  track.addEventListener 'scroll', updateArrows
  window.addEventListener 'resize', updateArrows

  # Pokud je container při načtení skrytý, zavoláme updateArrows/scrollToActive až když se zobrazí
  if track.offsetParent is null
    visibilityObserver = new MutationObserver ->
      if track.offsetParent isnt null
        updateArrows()
        scrollToActive()
        visibilityObserver.disconnect()
    visibilityObserver.observe document.body,
      attributes: true
      subtree: true
      attributeFilter: ['style', 'class']
  else
    updateArrows()
    scrollToActive()

  # --- "Klik přes pointerup" + drag ---
  isDown = false
  moved = false
  startX = 0
  startLeft = 0
  downTargetBtn = null
  DRAG_THRESHOLD = 5

  track.addEventListener 'dragstart', (e) -> e.preventDefault()

  track.addEventListener 'pointerdown', (e) ->
    isDown = true
    moved = false
    startX = e.clientX
    startLeft = track.scrollLeft
    downTargetBtn = e.target.closest('.themes_photo_product_selector')
    track.setPointerCapture e.pointerId
    track.classList.add 'is-dragging'
    track.style.scrollBehavior = 'auto'
    document.body.style.userSelect = 'none'

  track.addEventListener 'pointermove', (e) ->
    return unless isDown
    dx = e.clientX - startX
    if Math.abs(dx) > DRAG_THRESHOLD then moved = true
    track.scrollLeft = startLeft - dx

  track.addEventListener 'pointerup', (e) ->
    if track.hasPointerCapture(e.pointerId)
      track.releasePointerCapture e.pointerId
    document.body.style.userSelect = ''
    track.classList.remove 'is-dragging'
    track.style.scrollBehavior = ''
    isDown = false
    unless moved
      if downTargetBtn?
        handleSelect(downTargetBtn)
    downTargetBtn = null

  track.addEventListener 'pointercancel', ->
    isDown = false
    track.classList.remove 'is-dragging'
    track.style.scrollBehavior = ''
    document.body.style.userSelect = ''
    downTargetBtn = null

  # --- Klávesnice pro přístupnost (Enter/Space na buttonu) ---
  document.addEventListener 'keydown', (e) ->
    return unless e.target?.matches('.themes_photo_product_selector')
    if e.key is 'Enter' or e.key is ' '
      e.preventDefault()
      handleSelect(e.target)
